import { createRoutine } from 'redux-saga-routines';

export const fetchPosOrderByVisitTrackId = createRoutine(
  'FETCH_POS_ORDER_BY_VISIT_TRACK_ID'
);

export const createPosOrder = createRoutine('CREATE_POS_ORDER');

export const completePosOrder = createRoutine('COMPLETE_POS_ORDER');

export const cancelPosOrder = createRoutine('CANCEL_POS_ORDER');

export const adjustPosOrder = createRoutine('ADJUST_POS_ORDER');

export const addPosOrderItem = createRoutine('ADD_POS_ORDER_ITEM');

export const updatePosOrderItemQuantity = createRoutine(
  'UPDATE_POS_ORDER_ITEM_QUANTITY'
);

export const deletePosOrderItem = createRoutine('DELETE_POS_ORDER_ITEM');

export const deletePosOrderItems = createRoutine('DELETE_POS_ORDER_ITEMS');
